<template>
  <div class="otodetflzs">
    <div class="flzshed between">
      <div class="ti3">相关法律知识</div>
      <div class="flex_end">
        <div class="prev" @click="prev">
          <svg-icon icon-class="jt_right" class="flip180" />
        </div>
        <div class="next" @click="next"><svg-icon icon-class="jt_right" /></div>
      </div>
    </div>
    <div class="flzsswiper">
      <el-carousel
        trigger="click"
        height="190px"
        ref="flzsswiper"
        indicator-position="none"
        arrow="never"
        :autoplay="false"
      >
        <el-carousel-item v-for="item in 3" :key="item">
          <div class="flzsswiperlist between wrap">
            <div
              class="flzsswiperitem flex_start"
              v-for="i in 4"
              :key="i + 'b'"
            >
              <div class="flzitmcov">
                <img src="../../../assets/laws/jx_sample.png" />
              </div>
              <div>
                <div class="flzsbt">
                  {{
                    `法人、法定代表人、法人代表、法人代 表人`
                      | toEllipsisFilter(30)
                  }}
                </div>
                <div class="flzsydl">阅读量：48054</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    prev() {
      this.$refs.flzsswiper.prev();
    },
    next() {
      this.$refs.flzsswiper.next();
    },
  },
};
</script>

<style lang="scss" scoped>
.otodetflzs {
  padding: 40px;
  box-shadow: 0px 0px 8px 0px rgba(1, 1, 1, 0.08);
  .flzshed {
    .ti3 {
      font-size: 22px;
      color: #000000;
    }
    .prev,
    .next {
      width: 26px;
      height: 26px;
      text-align: center;
      line-height: 24px;
      color: #9999;
      border: 1px solid #f0f0f0;
      border-radius: 50%;
      margin-left: 10px;
      cursor: pointer;
      &:hover {
        background-color: rgb(240, 240, 240);
      }
    }
  }
  .flzsswiper {
    .flzsswiperlist {
      .flzsswiperitem {
        width: 400px;
        height: 75px;
        margin-top: 20px;
        align-items: flex-start;
        .flzitmcov {
          img {
            width: 116px;
            height: 72px;
            margin-right: 15px;
          }
        }
        .flzsbt {
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          height: 50px;
        }
        .flzsydl {
          font-size: 12px;
          color: #cccccc;
        }
      }
    }
  }
}
</style>